export const getLocationIdsWithPhotoEnabled = devices =>
  devices.reduce((locationIds, device) => {
    const { take_photos: takePhotos, locations } = device.settings;
    return takePhotos ? [...new Set([...locationIds, ...locations])] : locationIds;
  }, []);
